import React from "react";
import { Link, useLocation } from "react-router-dom";
import backArrow from "../../assets/back-arrow.png";
import PaymentHistoryTable from "./PaymentHistoryTable";

interface LocationState {
  from?: string;
  path?: string;
}

const PaymentHistory: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;

  // agar state hai to uska use karo, warna default Dashboard
  const backText = state?.from ? `Back to ${state.from}` : "Back to Dashboard";
  const backPath = state?.path || "/dashboard";

  return (
    <div className="page_main page_main-after-login mt-[100px] pt-[48px] bg-[#F7F8FA] pb-[100px]">
      <div className="custom-container">
        <Link to={backPath} className="font-bold flex items-center text-[#1B365D]">
          <img src={backArrow} alt="" className="me-2" aria-hidden />
          {backText}
        </Link>

        <div className="mt-7">
          <h1 className="heading-lg">Payment History</h1>
          <p className="text-[16px] mt-2 text-gray-600">
            View all your visa application payments and receipts
          </p>
        </div>

        <PaymentHistoryTable />
      </div>
    </div>
  );
};

export default PaymentHistory;
